function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import BufferParameters from './BufferParameters';
import Geometry from '../../geom/Geometry';
import BufferBuilder from './BufferBuilder';
import ScaledNoder from '../../noding/ScaledNoder';
import TopologyException from '../../geom/TopologyException';
import MathUtil from '../../math/MathUtil';
import PrecisionModel from '../../geom/PrecisionModel';
import RuntimeException from '../../../../../java/lang/RuntimeException';
import MCIndexSnapRounder from '../../noding/snapround/MCIndexSnapRounder';
var BufferOp = /*#__PURE__*/function () {
  function BufferOp() {
    _classCallCheck(this, BufferOp);
    BufferOp.constructor_.apply(this, arguments);
  }
  return _createClass(BufferOp, [{
    key: "bufferFixedPrecision",
    value: function bufferFixedPrecision(fixedPM) {
      var noder = new ScaledNoder(new MCIndexSnapRounder(new PrecisionModel(1.0)), fixedPM.getScale());
      var bufBuilder = new BufferBuilder(this._bufParams);
      bufBuilder.setWorkingPrecisionModel(fixedPM);
      bufBuilder.setNoder(noder);
      this._resultGeometry = bufBuilder.buffer(this._argGeom, this._distance);
    }
  }, {
    key: "bufferReducedPrecision",
    value: function bufferReducedPrecision() {
      if (arguments.length === 0) {
        for (var precDigits = BufferOp.MAX_PRECISION_DIGITS; precDigits >= 0; precDigits--) {
          try {
            this.bufferReducedPrecision(precDigits);
          } catch (ex) {
            if (ex instanceof TopologyException) {
              this._saveException = ex;
            } else throw ex;
          } finally {}
          if (this._resultGeometry !== null) return null;
        }
        throw this._saveException;
      } else if (arguments.length === 1) {
        var precisionDigits = arguments[0];
        var sizeBasedScaleFactor = BufferOp.precisionScaleFactor(this._argGeom, this._distance, precisionDigits);
        var fixedPM = new PrecisionModel(sizeBasedScaleFactor);
        this.bufferFixedPrecision(fixedPM);
      }
    }
  }, {
    key: "computeGeometry",
    value: function computeGeometry() {
      this.bufferOriginalPrecision();
      if (this._resultGeometry !== null) return null;
      var argPM = this._argGeom.getFactory().getPrecisionModel();
      if (argPM.getType() === PrecisionModel.FIXED) this.bufferFixedPrecision(argPM);else this.bufferReducedPrecision();
    }
  }, {
    key: "setQuadrantSegments",
    value: function setQuadrantSegments(quadrantSegments) {
      this._bufParams.setQuadrantSegments(quadrantSegments);
    }
  }, {
    key: "bufferOriginalPrecision",
    value: function bufferOriginalPrecision() {
      try {
        var bufBuilder = new BufferBuilder(this._bufParams);
        this._resultGeometry = bufBuilder.buffer(this._argGeom, this._distance);
      } catch (ex) {
        if (ex instanceof RuntimeException) {
          this._saveException = ex;
        } else throw ex;
      } finally {}
    }
  }, {
    key: "getResultGeometry",
    value: function getResultGeometry(distance) {
      this._distance = distance;
      this.computeGeometry();
      return this._resultGeometry;
    }
  }, {
    key: "setEndCapStyle",
    value: function setEndCapStyle(endCapStyle) {
      this._bufParams.setEndCapStyle(endCapStyle);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return BufferOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "bufferOp",
    value: function bufferOp() {
      if (arguments.length === 2) {
        var g = arguments[0];
        var distance = arguments[1];
        var gBuf = new BufferOp(g);
        var geomBuf = gBuf.getResultGeometry(distance);
        return geomBuf;
      } else if (arguments.length === 3) {
        if (Number.isInteger(arguments[2]) && arguments[0] instanceof Geometry && typeof arguments[1] === 'number') {
          var _g = arguments[0];
          var _distance = arguments[1];
          var quadrantSegments = arguments[2];
          var bufOp = new BufferOp(_g);
          bufOp.setQuadrantSegments(quadrantSegments);
          var _geomBuf = bufOp.getResultGeometry(_distance);
          return _geomBuf;
        } else if (arguments[2] instanceof BufferParameters && arguments[0] instanceof Geometry && typeof arguments[1] === 'number') {
          var _g2 = arguments[0];
          var _distance2 = arguments[1];
          var params = arguments[2];
          var _bufOp = new BufferOp(_g2, params);
          var _geomBuf2 = _bufOp.getResultGeometry(_distance2);
          return _geomBuf2;
        }
      } else if (arguments.length === 4) {
        var _g3 = arguments[0];
        var _distance3 = arguments[1];
        var _quadrantSegments = arguments[2];
        var endCapStyle = arguments[3];
        var _bufOp2 = new BufferOp(_g3);
        _bufOp2.setQuadrantSegments(_quadrantSegments);
        _bufOp2.setEndCapStyle(endCapStyle);
        var _geomBuf3 = _bufOp2.getResultGeometry(_distance3);
        return _geomBuf3;
      }
    }
  }, {
    key: "precisionScaleFactor",
    value: function precisionScaleFactor(g, distance, maxPrecisionDigits) {
      var env = g.getEnvelopeInternal();
      var envMax = MathUtil.max(Math.abs(env.getMaxX()), Math.abs(env.getMaxY()), Math.abs(env.getMinX()), Math.abs(env.getMinY()));
      var expandByDistance = distance > 0.0 ? distance : 0.0;
      var bufEnvMax = envMax + 2 * expandByDistance;
      var bufEnvPrecisionDigits = Math.trunc(Math.log(bufEnvMax) / Math.log(10) + 1.0);
      var minUnitLog10 = maxPrecisionDigits - bufEnvPrecisionDigits;
      var scaleFactor = Math.pow(10.0, minUnitLog10);
      return scaleFactor;
    }
  }]);
}();
export { BufferOp as default };
BufferOp.constructor_ = function () {
  this._argGeom = null;
  this._distance = null;
  this._bufParams = new BufferParameters();
  this._resultGeometry = null;
  this._saveException = null;
  if (arguments.length === 1) {
    var g = arguments[0];
    this._argGeom = g;
  } else if (arguments.length === 2) {
    var _g4 = arguments[0];
    var bufParams = arguments[1];
    this._argGeom = _g4;
    this._bufParams = bufParams;
  }
};
BufferOp.CAP_ROUND = BufferParameters.CAP_ROUND;
BufferOp.CAP_BUTT = BufferParameters.CAP_FLAT;
BufferOp.CAP_FLAT = BufferParameters.CAP_FLAT;
BufferOp.CAP_SQUARE = BufferParameters.CAP_SQUARE;
BufferOp.MAX_PRECISION_DIGITS = 12;